import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

export const initNativeFeatures = async () => {
  if (!Capacitor.isNativePlatform()) return;

  try {
    // Dark status bar to match the app's dark theme
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#171b24' }); // matches --background: 220 20% 10%
  } catch {}

  try {
    // Hide splash screen after app is ready (auto-show is default)
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {}
};
